// removed by extract-text-webpack-plugin
module.exports = {"exportButton":"action-panel__exportButton-29-qy blocks__huge-2XOet blocks__green-2w7kK blocks__button-1iODk","backButton":"action-panel__backButton-Amj9H blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk","openCrmLeadButton":"action-panel__openCrmLeadButton-35NPa blocks__huge-2XOet blocks__white-2DChO blocks__button-1iODk"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/bitrix-export-leads/action-panel/action-panel.css
// module id = 749
// module chunks = 0